export class Report {

    public id: string = "0";
    public name: string;
    public keys: any[];

    constructor() {}
}